<template>
  <div>
    <p>{{ $t('text.consentDenied')}}</p>
    <v-btn color="primary" @click.prevent="updateConsent()">{{ $t('button.updateConsent')}}</v-btn>
    <v-btn color="primary ma-1" @click.prevent="logout()">{{ $t('button.logout')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: "neoparent-consent-denied",
  methods: {
    updateConsent() {
      window.location.href = '/api/consent/url'
    },
    logout() {
      window.location.href = "/logout"
    }
  }
}
</script>

<style scoped>

</style>
